import PBSError from '../../../shared/PBSError'
import { loadScript } from '../../../shared/helpers'
import { getConsentPayload } from '../lib/utils'
import googleAnalytics4 from './googleAnalytics.js'
import { store } from '../store.js'
class ComcastBilling {
  constructor() {
    this.commerce = null
    this.firebolt = null

    this._initialize()

    this.consentPayload = {}
  }

  _initialize = async () => {
    await this._importFirebolt()
    await this._importCommerce()
  }

  _importFirebolt = async () => {
    try {
      const firebolt = await import('@firebolt-js/sdk')
      this.firebolt = firebolt
    } catch (error) {
      console.log(error)
      this._trigerSerntryError(error, 'OAT Error')
      throw new PBSError(error, 'DONATION_OAT_ERROR')
    }
  }

  _importCommerce = async () => {
    try {
      const commerce = await this._loadComcastBillingSDK()
      this.commerce = commerce
      this.commerce.setFirebolt(this.firebolt)
    } catch (error) {
      console.log(error)
    }
  }

  /**
   * @param {any} params { totalChargeAmount, stationCallSign, donationFrequency }
   * @returns {Promise} { consentToken, sku }
   */
  purchase = async (params) => {
    const oat = await this._getOAccountToken()
    this.consentPayload = await this._getConsentPayload({ ...params, oat })

    const consent = await this._getConsent()

    const { complete, data: { consentToken } = {} } = consent
    if (!complete) {
      throw new Error('Consent not completed')
    }
    return Promise.resolve({ consentToken, oat })
  }

  _getOAccountToken() {
    return this.commerce
      .getOAccountToken()
      .then((oat) => {
        return oat
      })
      .catch((e) => {
        this._trigerSerntryError(e, 'OAT Error')
        throw new PBSError(e, 'DONATION_OAT_ERROR')
      })
  }

  _getConsentPayload = async ({
    totalChargeAmount,
    donationType,
    donationFrequency,
    oat,
  }) => {
    googleAnalytics4.sendCustomEvent(
      'donation_form_submit',
      {
        donation_frequency:
          donationFrequency === MONTHLY ? 'monthly' : 'one-time',
        donation_amount: `$${totalChargeAmount}/${
          donationFrequency === MONTHLY ? 'month' : 'one-time'
        }`,
        donation_type: donationType,
        external_key: oat,
      },
      'In App Donation Screen'
    )
    let totalChargeAmountTransformed = +totalChargeAmount * 100
    let interval = donationFrequency === MONTHLY ? 'month' : ''
    let type = 'XfinityConsent'
    let gatewayCustomerId = oat

    const data = this._getData(
      totalChargeAmountTransformed,
      interval,
      type,
      gatewayCustomerId
    )
    const adaptedParams = await getConsentPayload(data)
      .then(this._consentAdapter)
      .catch((e) => {
        this._trigerSerntryError(e, 'ConsentPayload Error')
        throw new PBSError(e, 'TVAULT_CONSENT_PAYLOAD_ERROR')
      })

    return adaptedParams
  }

  _transformStringToUNIXTimestamp = (dateString) => {
    return parseInt(dateString, 10)
  }

  _consentAdapter = (consentResponse) => {
    let data = consentResponse.data.consent_payload[0]
    return {
      ...data,
      appName: 'PBS',
      productDetails: [
        {
          ...data.productDetails[0],
          startDate: this._transformStringToUNIXTimestamp(
            data.productDetails[0].startDate
          ),
          endDate: this._transformStringToUNIXTimestamp(
            data.productDetails[0].endDate
          ),
        },
      ],
    }
  }

  _getData = (totalChargeAmount, interval, type, gatewayCustomerId) => {
    const data = {
      data: {
        type,
        attributes: {
          amount: totalChargeAmount,
          gateway_customer_id: gatewayCustomerId,
        },
      },
    }

    if (interval !== '') {
      data.data.attributes.interval = interval
    }

    return data
  }

  _getConsent = async () => {
    try {
      const consent = new this.commerce.Consent(this.consentPayload, true)
      return this.commerce.render(consent).catch((error) => {
        console.log('e on _getConsent()')
        // TODO: set checkEligibilty flag to true
        this._trigerSerntryError(error, 'Consent Error')
        if (error.statusCode === 403 && error.message === 'User Ineligible') {
          throw error // TODO it is not the final implementation, Comcast should provide the error codes where they show their own UI with account resolution steps as it says in OTTERGA-1761 - Billing Consent Call Exception Handling - Treatment 3
        }
        throw new PBSError(error, 'DONATION_CONSENT_ERROR')
      })
    } catch (error) {
      console.log('e on _getConsent()', error)
      throw new PBSError(error, 'DONATION_CONSENT_ERROR')
    }
  }

  _trigerSerntryError(e, errorString) {
    const state = store.getState()
    PBSError.sendSentryError({
      errorString,
      errorTitle: 'ComcastBilling.tsx',
      extraParams: {
        errorCodeNumber: e.statusCode,
        errorCodeText: e.name,
        errorMessage: e.message,
        userPid: state.user.pid,
        partnerID: state.device.distributor,
        transactionID: e.transactionId,
      },
      visible: true,
    })
  }

  _loadComcastBillingSDK = async () => {
    return Promise.resolve(
      loadScript(
        'https://cdn.commerce.comcast.com/sdk/stage/commerce-render-generic.min.js'
      )
    ).then(() => import('../lib/comcastsdk/commerce.min.js'))
  }
}

export const MONTHLY = 'monthly'
export const ONETIME = 'onetime'

export default ComcastBilling
